import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '@core/componentes/navbar/navbar.component';
import { MenuVerticalComponent } from '@core/componentes/menu-vertical/menu-vertical.component';
import { SegundoNavbarComponent } from '@core/componentes/secondary-navbar/segundo-navbar.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import type { MenuItem } from 'primeng/api';
import { BreadcrumbService } from '@shared/servicios/breadcrumb.service';
import { PROVIDERS_LAYOUT } from '@core/layouts/providers-layout';

@Component({
  selector: 'app-default-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    SegundoNavbarComponent,
    MenuVerticalComponent,
    BreadcrumbModule
  ],
  providers: PROVIDERS_LAYOUT,
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent {
  public readonly home: MenuItem = { label: 'Inicio', routerLink: '/' };

  constructor(public readonly breadcrumbService: BreadcrumbService) {}
}